export const OPTHINES = {
  voteName: '2020project/2020cjly',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: 'rgb(74, 152, 13)',
    inactiveBgColor: 'rgb(242, 242, 242)',
  },
  tabs: [
    {
      tabName: '产品介绍',
      tabPath: '/20200306CJH/index',
    },
    {
      tabName: '相关新闻',
      tabPath: '/20200306CJH/news',
    },
    {
      tabName: '活动简介',
      tabPath: '/20200306CJH/rules',
    },
  ],
};
